/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_New_Validation_TestInputs */

const en_page_title_new_validation_test = /** @type {(inputs: Page_Title_New_Validation_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New validation test`)
};

const nl_page_title_new_validation_test = /** @type {(inputs: Page_Title_New_Validation_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe validatietest`)
};

/**
* | output |
* | --- |
* | "New validation test" |
*
* @param {Page_Title_New_Validation_TestInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_new_validation_test = /** @type {((inputs?: Page_Title_New_Validation_TestInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_New_Validation_TestInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_new_validation_test(inputs)
	return en_page_title_new_validation_test(inputs)
});